import { render } from "./EditCodeView.vue?vue&type=template&id=05bdca6c"
import script from "./EditCodeView.vue?vue&type=script&lang=js"
export * from "./EditCodeView.vue?vue&type=script&lang=js"

import "./EditCodeView.vue?vue&type=style&index=0&id=05bdca6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__